export const benefitsService = {
  verifyTx: 'verifyTx'
}

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)

  if (cleaned.length === 10 && match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`
  }

  return phoneNumberString
}

export const isValidPhoneNumber = (phoneNumberString) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  return cleaned.length === 10
}

export const isValidDate = (dateString) => {
  const dateRegex =
    /^(19[2-9]\d|20\d{2})\-(0[1-9]|1[0-2])\-(0[1-9]|1\d|2\d|3[01])$/
  const match = dateString.match(dateRegex)
  if (match) {
    const year = parseInt(match[1])
    return year > 1914
  }
  return false
}

export const EMAIL_REGEX = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/

export const NORMALIZED_NAME_INPUT = /^[a-zA-Z0-9\-.]*$/

export const sanitizeTextInput = (value) =>
  value.replace(/[^a-z0-9áéíóúñü@ \.,_-]/gim, '')
